module.exports = __webpack_public_path__ + "static/media/may_2025_2.f0bc2ff4.webp";